import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import FeedbackSlide from '../FeedbackSlide/FeedbackSlide';
import styled from 'styled-components';

export interface FeedbackFranchise {
  name: string;
  address: string;
  logo: string;
  text: string[];
}

const feedbackFranchiseData: FeedbackFranchise[] = [
  {
    name: 'Владимир',
    address: 'Якутск',
    logo: '/franchise-slide/photo7.jpg',
    text: [
      'В последнее время сервис шеринга стал достаточно популярен и была идея попробовать поработать в этом направлении. ',
      'В итоге увидев рекламу в соц. сетях сразу связались с EnerGO. О данном решении не пожалели и рады что сотрудничаем с такой командой.',
      'В работе только плюсы - любая помощь в работе, оперативное реагирование на проблемы, принятие и работа по обратной связи - поэтому можем оценить EnerGo как отличных партнеров'
    ]
  },
  {
    name: 'Мурад',
    address: 'Дагестан',
    logo: '/franchise-slide/photo4.jpg',
    text: [
      'Долго думали какой сервис запустить в нашей солнечной Республике Дагестан. Выбор пал на шеринг пауэрбанков!',
      'Среди всех представленных операторов выбрали EnerGO и не ошиблись. Оборудование в наличии и отправили сразу после оплаты, обучение прошли за пару дней и очень быстро разместили терминалы на точках.',
      'Первой поставкой заказали 67 терминалов, планируем расширение до 250-300 точек.'
    ]
  },

  {
    name: 'Максим',
    address: 'Краснодар',
    logo: '/franchise-slide/photo5.jpg',
    text: [
      'Моя первая франшиза. Ребята помогают по всем фронтам, начиная с регистрации ИП заканчивая отчетностью.',
      'В Краснодаре первое время было сложно ставить терминалы в новых местах из за присутствия конкурентов, но совместными усилиями мы это сделали и сервис моментально начал приносить доход. За неделю расставил свои терминалы и еще даже парочку докупил!'
    ]
  }
];

const FeedbackSlider = () => {
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return '<span class="' + className + '">' + '</span>';
    }
  };

  return (
    <>
      <StyledSwiper
        pagination={pagination}
        modules={[Pagination]}
        slidesPerView={3}
        spaceBetween={32}
        loop={true}
        className={'feedback-swiper'}
        breakpoints={{
          '320': {
            slidesPerView: 1
          },
          '600': {
            slidesPerView: 2
          },
          '1135': {
            slidesPerView: 3
          }
        }}
      >
        {feedbackFranchiseData.map(({ name, address, logo, text }, i) => (
          <SwiperSlide key={i}>
            <FeedbackSlide
              name={name}
              address={address}
              logo={logo}
              text={text}
            />
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </>
  );
};

const StyledSwiper = styled(Swiper)`
  margin-top: 56px;
  padding-bottom: 50px;
  & .swiper-wrapper {
    display: flex;
    align-items: stretch;
    // height: 436px;
  }
  & .swiper-pagination-bullet-active {
    background: #ffdc00;
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
  & .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
  // @media (max-width: 1500px) {
  //   & .swiper-wrapper {
  //     height: 470px;
  //   }
  // }
  // @media (max-width: 1380px) {
  //   & .swiper-wrapper {
  //     height: 490px;
  //   }
  // }
`;

export default FeedbackSlider;
